import { useClientVD } from '@solinkcorp/agent/hooks/useClientVD';
import { honoFetcher } from '@solinkcorp/agent/lib/honoFetcher';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';

export function useCreateInvestigation() {
  const client = useClientVD();
  const { mutate } = useSWRConfig();

  const createInvestigation = useCallback(
    async (params: { title: string; description?: string; visibility?: 'public' | 'private' }) => {
      const result = await honoFetcher(
        client.investigations.$post({
          json: {
            title: params.title,
            description: params.description ?? '',
            visibility: params.visibility ?? 'public',
          },
        }),
      );
      await mutate((key: unknown) => Array.isArray(key) && key[0] === 'investigations');
      return result;
    },
    [client, mutate],
  );

  return { createInvestigation };
}
